import { useCallback } from 'react'
import { useServerRequest } from '../api'
import {
  CURRENT_VERSION,
  type CalendarEventDataWithDetails,
  type CalendarEventListInput,
  type CalendarEventListSuccess,
} from '@terros/common'

export function useFetchCalendarEvents(): (
  input: CalendarEventListInput
) => Promise<CalendarEventDataWithDetails[]> {
  const request = useServerRequest<CalendarEventListInput, CalendarEventListSuccess>('/calendar/event/list')

  return useCallback(
    async (input: CalendarEventListInput): Promise<CalendarEventDataWithDetails[]> => {
      const response = await request({ ...input, version: CURRENT_VERSION })
      return response.events
    },
    [request]
  )
}
